module.exports = __webpack_public_path__ + "static/faq-banner-f4119f5b25817d4456a87712c3efbedf.png";